fragment flexibleSubsidies on flexibleSections_subsidies_BlockType {
    __typename
    subsidies: selectSubsidies {
        title
        uri
        ... on subsidy_Entry {
            uri
            periodsRelation(
                plainDate2: $now,
                orderBy: "plainDate2 ASC",
                limit: 1
            ) {
                id
                title
                ... on default_Entry {
                    start: plainDate
                    end: plainDate2
                }
            }
        }
    }
}
